import React from 'react'
import { useForm, Controller } from 'react-hook-form'
import InputForm from '../../components/forms/input/InputForm'
import SaveButton from '../../components/buttons/saveButton/SaveButton'

export default function ProposeConsiderApproveSummaryNoteForm({
  schema,
  showCommandButton,
  onSubmit = () => {},
}) {
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  return (
    <>
      {schema && (
        <>
          {showCommandButton ? (
            <>
              <InputForm
                schema={schema}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                rows={4}
                componentClass={'textarea'}
              />
              <SaveButton
                children={`บันทึก ${schema.label}`}
                style={{}}
                onClick={handleSubmit(onSubmit)}
              />
            </>
          ) : (
            <>
              <label>
                <b>{schema.label} :</b>
              </label>
              <div
                style={{ marginLeft: 20 }}
                dangerouslySetInnerHTML={{
                  __html: schema.value || '- ไม่ระบุ -',
                }}
              />
            </>
          )}
        </>
      )}
    </>
  )
}
